module.exports = __webpack_public_path__ + "img/downAppCode7.60226027.png";